export default __webpack_public_path__ + "static/media/bice-vida-search.0f94c2fe.png";